import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { catchError, Observable, throwError } from 'rxjs'
import { Router } from '@angular/router'
import { inject } from '@angular/core'

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.includes('assets/i18n')) {
    return next(req)
  }
  const router = inject(Router)
  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        if (window.location.pathname.startsWith('/teams/') || req.url.includes('/api/bot/')) {
          return throwError(() => error)
        }
        const redirectUrl = router.url
        if (redirectUrl === '/') {
          return throwError(() => error)
        }
        window.location.href = `/api/oauth-login-public/refresh-login?redirect_url=${encodeURIComponent(redirectUrl)}`
      }
      return throwError(() => error)
    })
  )
}
